import { render, staticRenderFns } from "./UserPromocodeStats.vue?vue&type=template&id=cbfd710e&scoped=true&"
import script from "./UserPromocodeStats.vue?vue&type=script&lang=js&"
export * from "./UserPromocodeStats.vue?vue&type=script&lang=js&"
import style0 from "./UserPromocodeStats.vue?vue&type=style&index=0&id=cbfd710e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfd710e",
  null
  
)

export default component.exports